import { render, staticRenderFns } from "./Outpatient.vue?vue&type=template&id=4fbcf07a&scoped=true"
import script from "./Outpatient.vue?vue&type=script&lang=js"
export * from "./Outpatient.vue?vue&type=script&lang=js"
import style0 from "./Outpatient.vue?vue&type=style&index=0&id=4fbcf07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbcf07a",
  null
  
)

export default component.exports